/* KINETIK PULSE — interactions (vanilla JS, no dependencies) */
(function () {
  "use strict";

  // Sticky add-to-cart visibility
  var sticky = document.querySelector("[data-kx-sticky]");
  if (sticky) {
    window.addEventListener("scroll", function () {
      if (window.scrollY > window.innerHeight * 0.9) sticky.classList.add("is-visible");
      else sticky.classList.remove("is-visible");
    });
  }

  // Hero product parallax + float
  var floatEl = document.querySelector("[data-kx-float]");
  if (floatEl) {
    var t = 0;
    function floatLoop() {
      t += 0.02;
      var y = Math.sin(t) * 18;
      var scroll = window.scrollY * 0.25;
      floatEl.style.transform = "translateY(" + (y + scroll) + "px)";
      requestAnimationFrame(floatLoop);
    }
    floatLoop();
  }

  // 3D gallery carousel controls
  document.querySelectorAll("[data-kx-carousel]").forEach(function (car) {
    var track = car.querySelector("[data-kx-track]");
    var prev = car.querySelector("[data-kx-prev]");
    var next = car.querySelector("[data-kx-next]");
    if (!track) return;
    var slide = track.querySelector(".kx-carousel__slide");
    var step = slide ? slide.offsetWidth + 20 : 400;
    if (next) next.addEventListener("click", function () { track.scrollBy({ left: step, behavior: "smooth" }); });
    if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -step, behavior: "smooth" }); });
  });

  // FAQ: single-open accordion behavior
  document.querySelectorAll("[data-kx-accordion]").forEach(function (acc) {
    var items = acc.querySelectorAll("details");
    items.forEach(function (item) {
      item.addEventListener("toggle", function () {
        if (item.open) items.forEach(function (o) { if (o !== item) o.open = false; });
      });
    });
  });

  // Header scroll state
  var header = document.querySelector("[data-kx-header]");
  if (header) {
    window.addEventListener("scroll", function () {
      header.style.background = window.scrollY > 40 ? "rgba(10,10,10,.7)" : "rgba(10,10,10,.5)";
    });
  }
})();
